import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import QuestionPrompt from '../QuestionPrompt';//eslint-disable-line import/no-named-as-default
import DialogPrompt from '../DialogPrompt';
import Option from './ConversationSingleAnswerOption';
import Button from '../../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as keyboardConstants from '../../../../constants/keyboardConstants';
import * as componentConstants from '../../../../constants/componentConstants';
import Feedback from '../singleAnswer/SingleAnswerFeedback';
import Label from '../../text/Label';
import Conversation from '../../conversationDialog/ChildConversationDialog';
import BadgeCollect from '../../badges/BadgeCollect';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as userDataHelper from '../../../../helpers/userDataHelper';
import * as xAPIHelper from '../../../../helpers/xAPIHelper';
import * as kpiHelper from '../../../../helpers/kpiHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as appConstants from '../../../../constants/appConstants';
import * as localStorage from '../../../../localStorage/localStorage';
import {LEANER_ACTION_REVIEW_CONFIG} from '../../../../models/dialogModels';
import * as animationHelper from "../../../../helpers/animationHelper";

class ConversationSingleAnswer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            options: this.props.screenObject.options,
            objectStates: objectConstants.OBJECT_DISPLAY_STATES,
            locale: appHelper.getLocalData(this.props.screenObject),
            reviewMode: false,
            propsUpdated: false,
            responseData: {
                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                asset_id: this.props.screenObject.asset_id,
                currentAttempt: 1,
                currentStatus: objectConstants.STATUS_NOT_STARTED,
                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                responses: [],
                latestResponse: {},
                scoring_type: this.props.screenObject.scoring_type
            },
            showPrompt: true,
            showOptions: false,
            showFeedback: false,
            showResponse: false,
            selectedOption: "",
            optionCanUpdate: true,
            animateResponse: true,
            noFeedback: {
                feedbackRequested: false,
                responseHandled: false
            },
            screenStatus: "",
            checkObjectStatus: false,
            handleCompletion: false,
            checkPostXAPIResponse: false,
            questionIsChecked: false,
            character_name: appHelper.isDefined(this.props.callbacks) ? this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
            focusedOption: this.props.screenObject.options[0],
            focusOnFeedback: false,
            optionCallbacks: {},
            updateFocus: false,
            showProgression: false,
            hideFeedback: false,
            progression_label: "",
            hasBadges: false,
            badgesCollected: false,
            animateBadge: true,
            completionSent: false,
            multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            try_again_label: appHelper.getLocaleString("try_again_label"),
            xApiResponseObj: {},
            usePreviousUserObjectData: true,
            animatePrompt: false,
        };

        this.getLocale = this.getLocale.bind(this);
        this.randomiseOptions = this.randomiseOptions.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.showFeedback = this.showFeedback.bind(this);
        this.showResponse = this.showResponse.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.reattempt = this.reattempt.bind(this);
        this.onReviewObject = this.onReviewObject.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.setReviewMode = this.setReviewMode.bind(this);
        this.scrollOptionsToTop = this.scrollOptionsToTop.bind(this);
        this.setOptionCanUpdate = this.setOptionCanUpdate.bind(this);
        this.getOptionCanUpdate = this.getOptionCanUpdate.bind(this);
        this.handleNoFeedback = this.handleNoFeedback.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.onFeedbackComplete = this.onFeedbackComplete.bind(this);
        this.handleAttemptComplete = this.handleAttemptComplete.bind(this);
        this.handleResponseComplete = this.handleResponseComplete.bind(this);
        this.postXAPIResponse = this.postXAPIResponse.bind(this);
        this.getOptionListClass = this.getOptionListClass.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getPrevOption = this.getPrevOption.bind(this);
        this.getNextOption = this.getNextOption.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.allowKeyAccessibility = this.allowKeyAccessibility.bind(this);
        this.onFocusOnFeedback = this.onFocusOnFeedback.bind(this);
        this.setOptionCallbacks = this.setOptionCallbacks.bind(this);
        this.setOptionFocus = this.setOptionFocus.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.onPromptRevealed = this.onPromptRevealed.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.checkResponses = this.checkResponses.bind(this);
        this.showOutcome = this.showOutcome.bind(this);
        this.show = this.show.bind(this);

        this.question = React.createRef();
    }

    componentDidMount() {
        //if (this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT || !this.state.screenObject.show_prompt) {
            this.randomiseOptions();
       // }
        this.setOptionCallbacks();
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.checkResponses();
        } else {
            this.getObjectStatus();
        }
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
        this.show();
    }

    componentWillReceiveProps(nextProps) {

        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkObjectStatus: true
            });
        }
        if (this.state.lang !== nextProps.lang) {
            let progression_label = "";
            if (this.state.progression_label === this.state.try_again_label) {
                progression_label = appHelper.getLocaleString("try_again_label");
            } else if (this.state.progression_label === this.state.continue_label) {
                progression_label = appHelper.getLocaleString("continue_label");
            }
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                progression_label: progression_label,
                multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
                try_again_label: appHelper.getLocaleString("try_again_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.setReviewMode();
        }

        if (this.state.checkObjectStatus) {
            this.getObjectStatus();
        }

        if (this.state.noFeedback.feedbackRequested && !this.state.noFeedback.responseHandled) {
            this.handleNoFeedback();
        }

        if (this.state.handleCompletion) {
            this.handleProgression();
        }
        if (this.state.checkPostXAPIResponse) {
            this.postXAPIResponse();
        }
        if (this.state.focusOnFeedback) {
            this.onFocusOnFeedback();
        }

        if (this.state.updateFocus) {
            this.setOptionFocus();
        }
    }

    show() {
        let question = this.question.current;
        if (appHelper.isDefined(question) && question !== null) {
            let params = {
                ele: question,
                duration: objectConstants.QUESTION_DURATION,
                delay: 0,
                callback: null
            };
            animationHelper.showHeight(params);
        }
    }

    postXAPIResponse() {
        this.setState({checkPostXAPIResponse: false});
        let interactionData = xAPIHelper.setSingleAnwserChoiceInteractionData(this.state.screenObject, this.state.responseData);
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
            let category = {
                constant: componentConstants.CONVERSATION_CHOICE,
                label: componentConstants.CONVERSATION_SINGLE_ANSWER_LABEL
            };
            this.props.actions.postActvityStatement(screen, interactionData, category);
        }
    }

    getAssets() {
        let characterAsset = appHelper.getCharacterAsset(this.state.screenObject.assets);

        if (characterAsset.src.length > 0) {
            this.props.callbacks.updateCharacterExpression(characterAsset);
        }
    }

    checkResponses() {
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let parentScreen = this.props.callbacks.getSubScreenParent();
            let params = {

                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
                asset_id: this.state.screenObject.asset_id,
            };

            let interactionData = xAPIHelper.getMultipleChoiceIds(params);

            this.props.actions.getActvityStatement(interactionData).then((responseObj) => {
                if (appHelper.isDefined(responseObj.statement) && appHelper.isDefined(responseObj.statement.result.completion)) {
                    this.setState({
                        xApiResponseObj: Object.assign({}, responseObj),
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            });
        }
    }

    getObjectStatus() {
        this.setState({checkObjectStatus: false});
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE && this.state.usePreviousUserObjectData) {
            let screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
            if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                this.setState({
                    reviewMode: true,
                    propsUpdated: true,
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        }
                    )
                });
            } else {
                let objectUserData = {};
                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                    let subScreenParent = this.props.callbacks.getSubScreenParent();
                    let screen_id = this.props.callbacks.getScreenId();
                    if (appHelper.isDefined(subScreenParent)) {
                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                    } else {
                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                    }
                }

                if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                    this.setState({
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            }
        }
    }

    setReviewMode() {
        let optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
        let kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
        if (appHelper.isDefined(kpiUserData)) {
            let optionDetails = appHelper.getOptionParentDetails(kpiUserData.option_id[0]);
            let showResponse = false;

            if (appHelper.isDefined(optionDetails)) {
                let responses = [];
                let response = {
                    selectedOption: optionDetails.option
                };

                if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
                    showResponse = true;
                }

                let hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0 && this.showOutcome();
                let enable_feedback = optionDetails.option.enable_feedback && this.showOutcome();
                let show_feedback_after_completion = optionDetails.option.feedback_settings.show_feedback_after_completion && this.showOutcome();

                let showProgression = !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && (!hasBadges || hasBadges && this.state.badgesCollected);
                this.setState(
                    {
                        showProgression: showProgression,
                        hasBadges: hasBadges,
                        badgesCollected: this.state.badgesCollected,
                        handleCompletion: true,
                        showPrompt: !this.state.screenObject.hide_prompt_after_completion,
                        propsUpdated: false,
                        showOptions: true,
                        showFeedback: show_feedback_after_completion && enable_feedback,
                        showResponse: showResponse,
                        options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
                        progression_label: optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                responses: dataHelper.immutablePush(responses, response),
                                latestResponse: optionDetails.option
                            }
                        ),
                        optionCanUpdate: false,
                    }
                );

                this.props.callbacks.updateCharacterExpression(optionDetails.option.character_pose);
            }
        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let responseObj = Object.assign({}, this.state.xApiResponseObj);
            //console.log(`responseObj`,responseObj);
            if (appHelper.isDefined(responseObj.statement)) {
                let responseString = responseObj.statement.result.response.toString();
                let choices = responseObj.statement.object.definition.choices;
                //let optionResponse = xAPIHelper.getChoiceByDescription(choices,responseString);
                let optionResponse = xAPIHelper.getChoiceById(choices, responseString);
                if (appHelper.isDefined(optionResponse.id)) {
                    let optionDetails = appHelper.getOptionParentDetails(parseInt(optionResponse.id));
                    if (appHelper.isDefined(optionDetails)) {
                        let showResponse = false;
                        let responses = [];
                        let response = {
                            selectedOption: optionDetails.option
                        };

                        if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
                            showResponse = true;
                        }
                        let show_feedback_after_completion = optionDetails.option.feedback_settings.show_feedback_after_completion && this.showOutcome();
                        let enable_feedback = optionDetails.option.enable_feedback && this.showOutcome();
                        let hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0 && this.showOutcome();
                        let showProgression = !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && (!hasBadges || hasBadges && this.state.badgesCollected);
                        this.setState(
                            {
                                showProgression: showProgression,
                                hasBadges: hasBadges,
                                badgesCollected: this.state.badgesCollected,
                                handleCompletion: true,
                                showPrompt: !this.state.screenObject.hide_prompt_after_completion,
                                propsUpdated: false,
                                showOptions: true,
                                showFeedback: show_feedback_after_completion && enable_feedback,
                                showResponse: showResponse,
                                options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
                                progression_label: optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
                                responseData: Object.assign(
                                    {}, this.state.responseData,
                                    {
                                        responses: dataHelper.immutablePush(responses, response),
                                        latestResponse: optionDetails.option
                                    }
                                ),
                                optionCanUpdate: false,
                            }
                        );
                    } else {
                        this.setState({
                            reviewMode: false,
                            propsUpdated: false,
                            usePreviousUserObjectData: false,
                            responseData: Object.assign(
                                {}, this.state.responseData,
                                {
                                    currentStatus: objectConstants.STATUS_NOT_STARTED,
                                    displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                                }
                            )
                        });
                    }
                } else {
                    this.setState({
                        reviewMode: false,
                        propsUpdated: false,
                        usePreviousUserObjectData: false,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_NOT_STARTED,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                            }
                        )
                    });

                }
            } else {
                this.setState({renderQuestions: true, propsUpdated: false, usePreviousUserObjectData: false,});
            }

        } else {
            this.setState({
                reviewMode: false,
                propsUpdated: false,
                usePreviousUserObjectData: false,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentStatus: objectConstants.STATUS_NOT_STARTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                    }
                )
            });
        }
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screenObject.locale);
        this.setState({locale: Object.assign({}, locale)});
        if (this.state.screenObject.show_title_in_header) {
            this.props.actions.setScreenTitle(locale.title);
        }
    }


    scrollOptionsToTop() {
        let questionOptions = this.refs[`${this.state.screenObject.asset_id}_questionOptions`];
        this.props.callbacks.scrollOptionsToTop(questionOptions.offsetTop);
    }

    randomiseOptions() {
        if (this.state.screenObject.randomise_options) {
            let options = dataHelper.randomiseArray(this.state.options);
            this.setState({
                options: options,
                showOptions: true,
                focusedOption: options[0]
            });
        } else {
            this.setState({showOptions: true});
        }
        this.props.callbacks.scrollToTop();
    }

    onPromptRevealed() {
        this.randomiseOptions();
    }

    renderOptions() {
        if (!this.state.showOptions && this.state.responseData.currentStatus === objectConstants.STATUS_NOT_STARTED) {
            this.setState({showOptions: true});
        }
        this.props.callbacks.scrollToTop();
    }

    showOutcome() {
        return !this.state.screenObject.hide_outcome || (this.state.screenObject.hide_outcome && this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE);
    }

    onOptionClick(event) {
        document.activeElement.blur();
        this.setOptionCanUpdate(true);
        let response = {
            selectedOption: appHelper.getObjectOption(this.state.screenObject.options, event.target.value)
        };
        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    responses: dataHelper.immutablePush(this.state.responseData.responses, response),
                    latestResponse: Object.assign({}, response.selectedOption)
                }
            ),
            progression_label: response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
            checkPostXAPIResponse: true,
            questionIsChecked: true
        });
    }


    handleAttemptComplete() {

        if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
            this.setState({showResponse: true, focusOnFeedback: true});
        } else {
            this.showFeedback();
        }
    }

    handleResponseComplete() {
        this.showFeedback();
    }

    showFeedback() {
        let latestResponseFeedbackLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
        let optionHasFeedback = appHelper.isDefined(latestResponseFeedbackLocale.feedback);
        if (optionHasFeedback && latestResponseFeedbackLocale.feedback.length === 0 || latestResponseFeedbackLocale.feedback === "<p><br></p>") {
            optionHasFeedback = false;
        }
        if (appHelper.isDefined(this.state.responseData.latestResponse.feedback_id)) {
            optionHasFeedback = true;
        }

        if (appHelper.isDefined(this.state.responseData.latestResponse.resources) && this.state.responseData.latestResponse.resources.length > 0) {
            optionHasFeedback = true;
        }

        if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            optionHasFeedback = true;
        }

        let bite = appHelper.getBite(this.props.callbacks.getBiteId());
        let score_kpi = kpiHelper.getScoreKpi(bite);

        if (this.state.screenObject.scoring_type === objectConstants.ASSESSED_TYPE_SCORED && score_kpi.is_visible) {
            optionHasFeedback = true;
        }

        if (appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0) {
            optionHasFeedback = true;
        }

        let enable_feedback = this.state.responseData.latestResponse.enable_feedback && this.showOutcome();


        if ((this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE && enable_feedback)) {

            this.setState({
                showFeedback: true,
                focusOnFeedback: true,

            });
        } else if ((!enable_feedback && !this.state.noFeedback.feedbackRequested) || (!optionHasFeedback && !this.state.noFeedback.feedbackRequested)) {
            let latestResponse = this.state.responseData.latestResponse;

            let selectedOptions = [latestResponse.option_id];

            let responseObj = {
                asset_id: this.state.screenObject.asset_id,
                selectedOptions: selectedOptions,
                kpis: latestResponse.kpis !== null ? latestResponse.kpis : [],
                indicators: appHelper.isDefined(latestResponse.indicators) && latestResponse.indicators !== null ? latestResponse.indicators : [],
            };

            this.props.callbacks.storeUserResponse(responseObj);
            if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
                this.setState({
                    showProgression: true,
                    progression_label: this.state.try_again_label
                });
            } else {
                if(!this.state.showResponse) {
                    this.handleResponse();
                }
                this.setState({

                    noFeedback: Object.assign({}, this.state.noFeedback,
                        {
                            feedbackRequested: true
                        }
                    )
                });
            }
        }
    }

    handleNoFeedback() {
        let enable_feedback = this.state.responseData.latestResponse.enable_feedback && this.showOutcome();

        /*if (appHelper.isDefined(this.state.responseData.latestResponse.audio)) {
            let audio = appHelper.getAudioAsset(this.state.responseData.latestResponse.audio);
            console.log(`audio`,audio);
            let audioObj = {
                audioRef: `audio_${audio.id}_${audio.type}`
            };

           // this.props.actions.setAudio(audioObj);
        }*/

        let hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback && this.showOutcome();
        let showProgression = this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && !hasBadges;

        this.setState({

            noFeedback: Object.assign({}, this.state.noFeedback,
                {
                    responseHandled: true
                }
            ),
            hasBadges: hasBadges,
            showProgression: showProgression,
        });

        if (!this.props.callbacks.hasNextObject(this.props.index) && !showProgression) {
            setTimeout(function () {
                // this.enableProgression(appHelper.getLocalData(this.state.responseData.latestResponse).progression_label);
            }.bind(this), 500);
        }

        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.responseData.latestResponse.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.responseData.latestResponse.character_pose);
        }
        //this.handleResponse();
        if (!hasBadges && !showProgression) {
            let handleResponse = this.handleResponse;
            setTimeout(function () {
                handleResponse();
            }, 1000);
        }
    }

    showResponse() {

        let optionLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
        let showResponse = true;
        if (!appHelper.isDefined(optionLocale.character_response)) {
            showResponse = false;
        } else if (appHelper.isDefined(optionLocale.character_response) && optionLocale.character_response.length === 0) {
            showResponse = false;
        } else if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
            showResponse = false;
        }
    }

    handleResponse() {
        this.setState({hideFeedback: false, showFeedback: this.state.hideFeedback ? false : this.state.showFeedback});
        let progressionRule = this.state.responseData.latestResponse.progression;
        if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.reattempt();
        } else {
            let optionLocale = appHelper.getLocalData(this.state.responseData.latestResponse);
            let enable_feedback = this.state.responseData.latestResponse.enable_feedback && this.showOutcome();

            /*if(!this.props.callbacks.hasNextObject(this.props.index)){
                this.setState({
                    showProgression: true,
                    progression_label: appHelper.getLocalData(this.state.responseData.latestResponse).progression_label
                });
                this.props.callbacks.scrollToContinue();
            }*/

            let show_feedback_after_completion = this.state.responseData.latestResponse.feedback_settings.show_feedback_after_completion;
            let showFeedbackOnceComplete = this.state.showFeedback && show_feedback_after_completion && progressionRule !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && enable_feedback;

            this.setState(
                {
                    //showFeedback: showFeedbackOnceComplete || (!this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW),
                    focusOnFeedback: showFeedbackOnceComplete || (!this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW),
                    showPrompt: !this.state.screenObject.hide_prompt_after_completion,
                    options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, this.state.responseData.latestResponse),
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED
                        }
                    )
                }
            );
            this.handleProgression();
        }
    }

    handleProgression() {
        this.setState({handleCompletion: false});
        if (!this.state.completionSent) {
            this.setState({completionSent: true});
            /*l
            let navigateToNextScreen = true;
            this.props.callbacks.onObjectComplete(progressionRule, this.state.screenObject.asset_id, this.state.responseData.latestResponse, navigateToNextScreen);*/
            let enable_feedback = this.state.responseData.latestResponse.enable_feedback && this.showOutcome();

            let progressionRule = this.state.responseData.latestResponse.progression;
            let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
            let progressionGoToId = appHelper.isDefined(this.state.responseData.latestResponse.progression_goto_id) ? this.state.responseData.latestResponse.progression_goto_id : undefined;
            let completionData = {
                progression: progressionRule,
                asset_id: this.state.screenObject.asset_id,
                status: objectConstants.STATUS_COMPLETE,
                asset_type_code: this.state.screenObject.asset_type_code,
                navigateToNextScreen: progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
                progressionType: progressionType,
                progressionGoToId: progressionGoToId,
                index: this.props.index,
                showProgression: this.state.showProgression,
            };

            this.props.callbacks.onObjectComplete(completionData);
        }
    }

    reattempt() {
        this.setState(
            {
                showFeedback: false,
                showResponse: false,
                questionIsChecked: false,
                focusedOption: this.state.options[0],
                updateFocus: true,
                optionCanUpdate: true,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentAttempt: this.state.responseData.currentAttempt + 1,
                        currentStatus: objectConstants.STATUS_ATTEMPTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY
                    }
                ),
                noFeedback: Object.assign({}, this.state.noFeedback,
                    {
                        responseHandled: false
                    }
                )
            }
        );
    }

    //REVEW POPUP
    onReviewObject(sourceId) {
        let config = Object.assign({}, LEANER_ACTION_REVIEW_CONFIG,
            {
                title: this.state.locale.label,
                sourceId: sourceId
            }
        );
        //locale.title

        for (let i = 0; i < config.childComponents.length; i++) {
            let child = config.childComponents[i];
            child.componentProps = Object.assign({}, {
                screenObject: this.state.screenObject,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        callbacks: this.props.callbacks,

                    }
                ),
                callbacks: this.props.callbacks,
                optionCanUpdate: false,
            });
        }
        this.props.actions.setNewDialog(config);
    }

    setOptionCanUpdate(canUpdate) {
        this.setState({optionCanUpdate: canUpdate});
    }

    getOptionCanUpdate() {
        return this.state.optionCanUpdate;
    }

    onFeedbackComplete() {

    }

    getOptionListClass() {
        return this.state.questionIsChecked ? "question-checked" : "";
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }


    getPrevOption() {
        let optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
        let nextOption = this.state.options[optionIndex - 1];
        if (optionIndex <= 0) {
            nextOption = this.state.options[this.state.options.length - 1];
        }

        this.setState({focusedOption: Object.assign({}, nextOption), updateFocus: true});
    }

    getNextOption() {
        let optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
        let nextOption = this.state.options[optionIndex + 1];
        if (optionIndex === (this.state.options.length - 1)) {
            nextOption = this.state.options[0];
        }
        this.setState({focusedOption: Object.assign({}, nextOption), updateFocus: true});
    }

    allowKeyAccessibility() {
        let responseData = this.state.responseData;
        //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
        if (responseData.currentAttempt === responseData.responses.length) {
            return false;
        } else {
            //console.log()
            for (let i = 0; i < this.state.responseData.responses.length; i++) {
                let response = this.state.responseData.responses[i];
                if (response.selectedOption.option_id === this.state.focusedOption.option_id) {
                    return false;
                }
            }
            return true;
        }
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.allowKeyAccessibility()) {
                this.onOptionClick({target: {value: this.state.focusedOption.option_id}});
            } else {
                let responseData = this.state.responseData;
                if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.latestResponse.feedback_settings) && this.state.responseData.latestResponse.feedback_settings.include_explore_feedback) {
                    this.onReviewObject(`option_${this.state.focusedOption.option_id}`);
                }
            }
        }

        if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
            event.preventDefault();
            this.getPrevOption();
        }

        if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
            event.preventDefault();
            this.getNextOption();
        }

        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.preventDefault();
            this.getPrevOption();
        }

        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.preventDefault();
            this.getNextOption();
        }
    }

    onFocusOnFeedback() {
        let focusEl = document.getElementById(`feedback_wrapper_${this.state.screenObject.asset_id}`);
        if (appHelper.isDefined(focusEl) && focusEl !== null) {
            focusEl.focus();
        }
        this.setState({focusOnFeedback: false});
    }

    setOptionCallbacks() {
        this.setState({
            optionCallbacks: Object.assign({}, this.state.optionCallbacks, {
                setKeyboardAccessibility: this.setKeyboardAccessibility
            })
        });
    }

    setOptionFocus() {
        let focusEl = document.getElementById(`option_${this.state.focusedOption.option_id}`);
        focusEl.focus();
        this.setState({updateFocus: false});
    }

    enableProgression(progression_label) {
        let hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && this.showOutcome();
        let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;

        let showProgression = !hasBadges;
        if (!this.props.callbacks.hasNextObject(this.props.index)) {
            showProgression = (!hasBadges || hasBadges && this.state.badgesCollected) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TERMINAL;
        }
        this.setState({
            showProgression: showProgression,
            hasBadges: hasBadges,
            progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
        });
        this.props.callbacks.scrollToContinue();
    }

    onProgressionClicked() {
        let show_feedback_after_completion = this.state.responseData.latestResponse.feedback_settings.show_feedback_after_completion && this.showOutcome();
        let showFeedbackOnceComplete = show_feedback_after_completion && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN;
        let hideFeedback = !showFeedbackOnceComplete && (this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN);
        this.setState({
            showProgression: false,
            hideFeedback: hideFeedback,
        });

        if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.props.callbacks.navigateToNextScreen();
        } else if (this.props.callbacks.hasNextObject(this.props.index) && !hideFeedback) {
            this.handleResponse();
        } else if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.reattempt();
        }else if(this.props.callbacks.hasNextObject(this.props.index)){
            this.handleResponse();
        }
    }

    onBadgeCollected() {
        let show_feedback_after_completion = this.state.responseData.latestResponse.feedback_settings.show_feedback_after_completion && this.showOutcome();
        let showFeedbackOnceComplete = this.state.showFeedback && show_feedback_after_completion && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN;
        this.setState({badgesCollected: true, showFeedback: showFeedbackOnceComplete});

        if (!this.props.callbacks.hasNextObject(this.props.index)) {
            this.setState({
                showProgression: true,
                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
            });
            this.props.callbacks.scrollToContinue();
        }
        this.handleResponse();

        //this.hide();
    }

    render() {
        let customLearnerName = this.props.callbacks.checkLearnerDisplayName();
        let learnersName = this.state.you_label;

        if (this.props.trackingData.first_name.length > 0 && !this.props.trackingData.first_name.includes('Guest') && (!appHelper.isDefined(this.props.contentData.experience.learner_name_display_type) || (appHelper.isDefined(this.props.contentData.experience.learner_name_display_type) && this.props.contentData.experience.learner_name_display_type !== objectConstants.YOU))) {
            learnersName = this.props.trackingData.first_name;
        }

        if (customLearnerName.length > 0) {
            learnersName = customLearnerName;
        }
        return (
            <div className="a-c" ref={this.question}>
                <div className="learner-action" role={'application'}>
                    <p className="hidden-el">{this.state.multiple_choice_single_answer_question_label}</p>

                    {
                        appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0
                            ?
                            <div className={`content-character-expression`}>
                                <img src={this.getImagePath(this.props.characterPose.src)} alt=""/>
                            </div>
                            :
                            null
                    }

                    <div className="question-wrapper conversation">

                        {
                            this.state.screenObject.prompt_type !== objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT && this.state.screenObject.show_prompt
                                ?
                                this.state.screenObject.prompt_settings.class_name === objectConstants.DIALOG
                                    ?

                                    <div className="object-container">
                                        <DialogPrompt character_name={this.state.character_name}
                                                      screenObject={this.state.screenObject}
                                                      onComplete={this.onPromptRevealed}
                                                      animatePrompt={this.state.animatePrompt}
                                        />
                                    </div>
                                    :
                                    <QuestionPrompt screenObject={this.state.screenObject}
                                                    onComplete={this.onPromptRevealed}
                                                    animatePrompt={this.state.animatePrompt}/>
                                :
                                null
                        }
                        {this.state.showOptions
                            ?
                            <div>

                                <Label screenObject={this.state.screenObject}
                                       id={`${this.state.screenObject.asset_id}_user_name`}
                                       container_class_name={`object-container-no-margin`}
                                       class_name={`user_name_label`}
                                       htmlFor=""
                                       text={learnersName}/>

                            </div>
                            :
                            null
                        }


                        {this.state.showOptions
                            ?
                            <div
                                className={`learner-action-option-list user theme-active ${this.getOptionListClass()} ${this.props.contentData.experience.speech_bubble_corner_style !== null ? this.props.contentData.experience.speech_bubble_corner_style : 'round'}`}
                                role="radiogroup" ref={`${this.state.screenObject.asset_id}_questionOptions`}>
                                {this.state.options.map(option =>
                                    <Option key={option.option_id} option={option}
                                            asset_id={this.state.screenObject.asset_id}
                                            questionChecked={this.state.questionChecked}
                                            onOptionClick={this.onOptionClick}
                                            responseData={this.state.responseData}
                                            onAttemptComplete={this.handleAttemptComplete}
                                            onOptionRevealed={this.scrollOptionsToTop}
                                            onReviewObject={this.onReviewObject}
                                            index={appHelper.getObjectOptionIndex(this.state.screenObject.options, option.option_id)}
                                            showFeedback={appHelper.isDefined(this.state.responseData.latestResponse.enable_feedback) && this.state.responseData.latestResponse.enable_feedback && this.showOutcome()}
                                            setOptionCanUpdate={this.setOptionCanUpdate}
                                            getOptionCanUpdate={this.getOptionCanUpdate}
                                            optionCanUpdate={this.state.optionCanUpdate}
                                            focusedOption={this.state.focusedOption}
                                            optionCallbacks={this.state.optionCallbacks}
                                    />
                                )}
                            </div>
                            : null
                        }
                        {this.state.showResponse || this.state.showFeedback
                            ?
                            <div ref={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                                 id={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                                 tabIndex={0}
                                 className="feedback-focus">

                                {this.state.showResponse
                                    ?
                                    <Conversation asset_id={this.state.screenObject.asset_id}
                                                  option_id={this.state.responseData.latestResponse.option_id}
                                                  dialogs={this.state.responseData.latestResponse.dialogs}
                                                  callbacks={this.props.callbacks}
                                                  onComplete={this.handleResponseComplete}/>
                                    :
                                    null
                                }

                                {
                                    this.state.showFeedback
                                        ? <Feedback screenObject={this.state.screenObject}
                                                    option={this.state.responseData.latestResponse}
                                                    options={this.state.screenObject.options}
                                                    asset_id={this.state.screenObject.asset_id}
                                                    responseData={this.state.responseData}
                                                    onComplete={this.handleResponse}
                                                    onShowReview={this.onReviewObject}
                                                    showFeedback={appHelper.isDefined(this.state.responseData.latestResponse.enable_feedback) && !this.state.responseData.latestResponse.enable_feedback && this.showOutcome()}
                                                    onEnableProgression={this.enableProgression}
                                                    hideFeedback={this.state.hideFeedback}
                                                    index={this.props.index}
                                                    callbacks={this.props.callbacks}/>
                                        : null
                                }
                            </div>
                            : null
                        }
                        {(this.state.showResponse || this.state.showFeedback) && this.state.hasBadges
                            ?
                            <br/>
                            :
                            null
                        }

                        {
                            this.state.hasBadges
                                ?
                                <div className="badge-wrapper">
                                    {this.state.responseData.latestResponse.badges.map(badge =>
                                        <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id}
                                                      bite_id={this.props.callbacks.getBiteId()}
                                                      asset_id={this.state.screenObject.asset_id}
                                                      onCollected={this.onBadgeCollected}
                                                      animate={this.state.animateBadge}/>
                                    )}
                                </div>
                                : null
                        }
                    </div>
                    {this.state.showProgression
                        ?
                        <Button label={this.state.progression_label} id={`${this.state.screenObject.asset_id}_button`}
                                ref={`${this.state.screenObject.asset_id}_button`}
                                onClick={this.onProgressionClicked}/>
                        : null

                    }
                </div>
            </div>


        );
    }
}

ConversationSingleAnswer.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    characterPose: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    index: PropTypes.number,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ConversationSingleAnswer.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConversationSingleAnswer);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/conversationSingleAnswer/ConversationSingleAnswer.js
 **/